import { ErrorHandler, Inject, Injectable, Injector } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';

import { ErrorHandlerConfigService } from '../models/error-handler-config.interface';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';
import { HttpErrorHandlerService } from './http-error-handler.service';

// error handler for portfolio analyser application that calls a chain of error handlers
@Injectable()
export class ErrorHandlerService implements ErrorHandler {
	private errorPopupService: ErrorPopupService;
	private errorHelperService: ErrorHelperService;

	constructor(
		@Inject(ErrorHandlerConfigService) private config,
		private contentService: ContentService,
		private injector: Injector,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) { }

	public handleError(error): void {
		this.errorPopupService = this.injector.get(ErrorPopupService);
		this.errorHelperService = this.injector.get(ErrorHelperService);

		const httpErrorHandler = new HttpErrorHandlerService(
			this.contentService,
			this.errorPopupService,
			this.tealiumAnalyticsService,
			this.errorHelperService
		);

		let handler: AbstractErrorHandlerService = httpErrorHandler;
		this.config.useErrorHandlers.map(newHandler => {
			const nextHandler = new newHandler(this.contentService, this.errorPopupService, this.tealiumAnalyticsService, this.errorHelperService);
			handler.setNextHandler(nextHandler);
			handler = nextHandler;
		});
		return httpErrorHandler.handleError(error);
	}
}
